import React from 'react';
import BlogList from '../components/Blog/BlogList';
import usePageMeta from '../hooks/usePageMeta';

const Blog: React.FC = () => {
  usePageMeta({
    title: 'Blog',
    description:
      'Artigos sobre tecnologia, integração de sistemas, automação de processos e desenvolvimento de software.',
    path: '/blog',
  });

  return <BlogList />;
};

export default Blog;